module.exports = __webpack_public_path__ + "static/ghast-mtg_afr-6b8aac5b040f76306eb1742e0a5832cd.jpg";